module.exports = __webpack_public_path__ + "static/img/inv-1.f3055fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/inv-1.png
// module id = fvhz
// module chunks = 0